import { render } from "./lrb.vue?vue&type=template&id=2fa732fb&scoped=true&ts=true"
import script from "./lrb.vue?vue&type=script&lang=ts"
export * from "./lrb.vue?vue&type=script&lang=ts"

import "./lrb.vue?vue&type=style&index=0&id=2fa732fb&lang=less&scoped=true"

import exportComponent from "E:\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fa732fb"]])

export default __exports__